import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';

export type Payment = {
  mid: string; // 상점아이디
  payload?: string; // API 응답에 돌려받을 가맹점 데이터
  cancelType?: string; // 취소처리구분
  orgTradeKeyType?: string; // 거래키구분
  orgTradeKey?: string; // 원거래 키
  orgTradeDate?: string; // 원거래일자
  cancelTotalAmount?: string; // 취소 총 금액
  cancelTaxFreeAmount?: string; // 취소 면세금액
  cancelSeq?: string; // 취소일련번호
  orderNumb?: string; // 가맹점 주문 번호
  userName?: string; // 주문자명
  userEmail?: string; // 주문자 이메일
  totalAmount?: number; // 총금액
  bankType?: string; // 은행타입
  closeDateTime?: string; // 마감 일시
  userInfoType?: string;
  userInfo?: string;
  issueUsageType?: string;
  expiryDate?: string;
  password2?: string;
  productType?: string; // 상품구분 (REAL or DIGITAL)
  productName?: string; // 상품명
  orderNumber?: string;
};

const $http = new APIManager();

const Api = {
  /**
   * [POST] Payment
   * --
   */
  paymentCancelCard: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.CANCEL_CARD, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Account Cancel
   * --
   */
  paymentCancelAccount: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.CANCEL_ACCOUNT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Mobile Cancel
   * --
   */
  paymentCancelMobile: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.CANCEL_MOBILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Onetime Vacccount Issue
   * --
   */
  paymentIssueOnetimeVaccount: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.ISSUE_ONETIME_VACCOUNT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Vacccount Recall
   * --
   */
  paymentRecallVaccount: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.RECALL_VACCOUNT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Cashbill Issue
   * --
   */
  paymentIssueCashbill: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.ISSUE_CASHBILL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Cashbill Cancel
   * --
   */
  paymentCancelCashbill: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.CANCEL_CASHBILL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Billing Regist
   * --
   */
  paymentRegistBilling: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.REGIST_BILLING, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Billing DeRegist
   * --
   */
  paymentDeRegistBilling: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.DEREGIST_BILLING, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Billing Query
   * --
   */
  paymentQueryBilling: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.QUERY_BILLING, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Payment Billing Pay
   * --
   */
  paymentPayBilling: async (body: Payment) => {
    try {
      const res = await $http.post(APIConstant.PAY_BILLING, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
